var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHansefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 90,
    viewBox: "0 0 180 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H172C176.418 0 180 3.58172 180 8V82C180 86.4183 176.418 90 172 90H8C3.58172 90 0 86.4183 0 82V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2119_972",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 179,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 88,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2119_972)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2119_972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2739 37.4017L69.6861 51.9472H66.5174L67.5736 46.066H62.6093L61.553 51.9472H58.3843L61.0249 37.4017H64.1936L63.1374 43.2304H68.1018L69.158 37.4017H72.2739Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9387 49.5842H76.7631L75.654 51.9472H72.2212L79.4037 37.4017H83.5759L85.6356 51.9472H82.2027L81.9387 49.5842ZM81.6218 46.8537L81.2521 43.1779C81.1465 42.1802 81.0409 40.6049 81.0937 39.9222H81.0409C80.8824 40.6574 80.1959 42.1802 79.7734 43.1779L78.0306 46.8537H81.6218Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.571 46.9587H97.6238C97.6767 45.8559 97.9935 43.703 98.152 42.7053L99.1026 37.4017H102.166L99.5779 51.9472H96.6204L93.8742 45.961C93.346 44.8582 92.8179 43.3879 92.7123 42.5478H92.6595C92.6067 43.6505 92.2898 45.8034 92.1313 46.8011L91.2335 51.9472H88.1704L90.7582 37.4017H93.7157L96.5148 43.6505C96.9373 44.6482 97.4654 46.171 97.571 46.9587Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.176 42.1277C105.176 38.8195 107.817 37.1392 111.408 37.1392C115.158 37.1392 116.636 38.977 116.108 41.6026H112.781C112.992 40.5524 112.57 39.7122 110.933 39.7122C109.243 39.7122 108.503 40.6049 108.503 41.6026C108.503 42.3377 109.031 42.7053 110.088 43.0729L112.623 44.0181C114.154 44.5957 115.158 45.5934 115.158 47.2212C115.158 50.5294 112.306 52.2622 108.662 52.2622C104.595 52.2622 103.275 50.2668 103.803 47.6413H107.13C106.919 48.7965 107.394 49.6892 109.137 49.6892C110.88 49.6892 111.725 48.849 111.725 47.7988C111.725 47.0112 111.091 46.6961 110.352 46.4335L107.553 45.3308C106.127 44.7532 105.176 43.703 105.176 42.1277Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.132 40.1848L122.551 43.3879H128.413L127.938 45.961H122.076L121.495 49.2166H128.044L127.568 51.9997H117.904L120.492 37.4542H130.156L129.681 40.2373H123.132V40.1848Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.758 40.1848L136.124 43.6505H141.881L141.405 46.4336H135.649L134.698 51.9472H131.53L134.117 37.4017H143.676L143.201 40.1848H136.758Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.479 51.9472H144.31L146.898 37.4017H150.067L147.479 51.9472Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.64 40.1848H159.784L157.725 51.9472H154.556L156.616 40.1848H152.76L153.236 37.4017H164.115L163.64 40.1848Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4443 29V60.2438H45.8677V29H14.4443ZM27.0665 52.0522H23.845L24.9012 46.066H19.884L20.4121 43.1779H25.4821L26.5384 37.2442H29.7599L27.0665 52.0522ZM39.7415 46.0135H34.7243L33.6681 51.9997H30.4465L33.0871 37.1917H36.3087L35.2524 43.1254H40.3224L39.7415 46.0135Z",
    fill: "#455A64"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2119_972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.556,
    height: 32,
    fill: "white",
    transform: "translate(14.4443 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHansefit);
export default __webpack_public_path__ + "static/media/hansefit.7cd046271560d9498ecb4487f7f6f069.svg";
export { ForwardRef as ReactComponent };